import React from 'react';
import { Box, Typography } from '@mui/material';
import FinnixProLogo from './FinnixProLogo';
export default function FinnixProWordmark({ variant = 'color' }) {
  return <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, color: variant === 'reversed' ? 'common.white' : variant === 'monochrome' ? 'inherit' : 'primary.main' }}><FinnixProLogo size={34} decorative variant={variant} /><Typography component="span" sx={{ color: 'inherit', fontFamily: '"Inter Tight", Inter, sans-serif', fontSize: '1.6rem', fontWeight: 800, letterSpacing: '-0.04em', lineHeight: 1 }}>FinnixPro</Typography></Box>;
}
